import { Component, OnInit, Input, EventEmitter, Output, OnDestroy } from '@angular/core';
import { SpinnerService } from '../../../../core/services/spinner.service';

@Component({
  selector: 'spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent implements OnInit, OnDestroy {
  @Input() name: string;
  @Input() group: string;
  @Input() loadingImage: string;

  @Output() showChange = new EventEmitter();

  private isShowing = false;

  constructor(private spinnerService: SpinnerService) {}

  @Input()
  get show(): boolean {
    return this.isShowing;
  }

  set show(val: boolean) {
    this.isShowing = val;
    this.showChange.emit(this.isShowing);
  }

  ngOnInit(): void {
    if (!this.name) {
      throw new Error('Spinner must have a \'name\' attribute.');
    }
    this.spinnerService.register(this);
  }

  ngOnDestroy(): void {
    this.spinnerService.unregister(this);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/_utils/templates/spinner/spinner.component.ts